// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1D87A","img":"styles_img__hzq5Q","back-btn":"styles_back-btn__9an4P","backBtn":"styles_back-btn__9an4P"};